export const dataTypes = {
    text: "Text",
    number: "Number",
    date: "Date",
    image: "Image",
    barCode: "BarCode",
    companyInfo: "CompanyInfo",
    systemTasks: "SystemTaskSettings",
    templates: "MessageTemplates"
};